module.exports = __webpack_public_path__ + "static/media/loading.a06ddb3a.gif";